import { Script } from "../../components/Script";
export var Script3D = Script;
